<template>
	<div v-parallax-fit="parallax" class="room">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/15_MovingBoxes@2x.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 17000,
						end: 20000,
						fromStyle: { transform: 'translateX(500%) translateY(0%) rotate(0deg)' },
           				toStyle: { transform: 'translateX(0%) translateY(0%) rotate(0deg)' },
						easing: 'linear'
					},
					{
						start: 22000,
						end: 24000,
						fromStyle: { transform: 'translateX(0%) translateY(0%) rotate(0deg)' },
           				toStyle: { transform: 'translateX(0%) translateY(500%) rotate(-45deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.room {
		position: absolute;
	    left: -17%;
	    bottom: -17%;
	    min-width: 800px;
	    transition: all 0.8s linear;
	}

	@media screen and (max-width: 1600px) {
		.room {min-width: 750px;}
	}

	@media screen and (max-width: 991px) {
		.room {min-width: 610px;}
	}

	@media screen and (max-width: 650px) {
		.room {min-width: 395px;}
	}
</style>
